export enum LogDates {
    Last7Days = 'Last7Days',
    Last30Days = 'Last30Days',
    Last90Days = 'Last90Days',
    Last6Months = 'Last6Months',
    Last12Months = 'Last12Months'
}
